import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ivr_empty",
  "use": "ivr_empty-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 40 40\" id=\"ivr_empty\">\r\n<path class=\"st0\" d=\"M26.4,2H7C5.3,2,4,3.3,4,5v30c0,1.6,1.3,3,3,3h26c1.7,0,3-1.3,3-3V11.5L26.4,2z M26.5,4.9l6.1,6.1h-6.1V4.9z\r\n\t M33,36H7c-0.6,0-1-0.4-1-1V5c0-0.5,0.4-1,1-1h17.5v9H34v22C34,35.6,33.6,36,33,36z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol